module.exports = __webpack_public_path__ + "img/icon-menu.beee4cc8.svg";